import { CALL_API, Schemas } from '../../common/middleware/api';

export const WORKSHOP_ENROLMENT_FETCH_REQUEST = 'WORKSHOP_ENROLMENT_GET_REQUEST';
export const WORKSHOP_ENROLMENT_FETCH_SUCCESS = 'WORKSHOP_ENROLMENT_GET_SUCCESS';
export const WORKSHOP_ENROLMENT_FETCH_FAILURE = 'WORKSHOP_ENROLMENT_GET_FAILURE';

export const WORKSHOP_ENROLMENTS_REQUEST = 'WORKSHOP_ENROLMENTS_REQUEST';
export const WORKSHOP_ENROLMENTS_SUCCESS = 'WORKSHOP_ENROLMENTS_SUCCESS';
export const WORKSHOP_ENROLMENTS_FAILURE = 'WORKSHOP_ENROLMENTS_FAILURE';

export const CHILD_WORKSHOP_SESSIONS_DASHBOARD_REQUEST = 'CHILD_WORKSHOP_SESSIONS_DASHBOARD_REQUEST';
export const CHILD_WORKSHOP_SESSIONS_DASHBOARD_SUCCESS = 'CHILD_WORKSHOP_SESSIONS_DASHBOARD_SUCCESS';
export const CHILD_WORKSHOP_SESSIONS_DASHBOARD_FAILURE = 'CHILD_WORKSHOP_SESSIONS_DASHBOARD_FAILURE';

export const loadWorkshopEnrolments = (options) => ({
	[CALL_API]: {
		types: [WORKSHOP_ENROLMENTS_REQUEST, WORKSHOP_ENROLMENTS_SUCCESS, WORKSHOP_ENROLMENTS_FAILURE],
		endpoint: 'api/workshopEnrolments',
		request: options,
		schema: Schemas.WORKSHOP_ENROLMENT_ARRAY
	}
});

export const fetchWorkshopEnrolment = (id) => ({
	[CALL_API]: {
		types: [WORKSHOP_ENROLMENT_FETCH_REQUEST, WORKSHOP_ENROLMENT_FETCH_SUCCESS, WORKSHOP_ENROLMENT_FETCH_FAILURE],
		endpoint: `api/workshopEnrolments/${id}`,
		schema: Schemas.WORKSHOP_ENROLMENT
	}
});

export const loadChildWorkshopSessionsForDashboard = () => ({
	[CALL_API]: {
		types: [CHILD_WORKSHOP_SESSIONS_DASHBOARD_REQUEST, CHILD_WORKSHOP_SESSIONS_DASHBOARD_SUCCESS, CHILD_WORKSHOP_SESSIONS_DASHBOARD_FAILURE],
		endpoint: `api/childWorkshopSessions/dashboard`,
		schema: Schemas.CHILD_WORKSHOP_SESSIONS_DASHBOARD_ARRAY
	}
});